import type { IMailingAddress } from '../shared/address';
import type { ILocation } from '../shared/location';
import type { AreaValue } from '../shared/units';

/**
 * Handover metadata as returned by general Property reads. The handover code and buyer email are
 * never part of it; the active handover comes from the `properties:handover` operation.
 */
export interface PropertyHandoverMeta {
  createdByOrgID?: string; // builder org that created it
  createdByUserID?: string; // builder user who created it
  templateID?: string;

  // when a handover is initiated
  pendingOwnerUserID?: string; // invited buyer userID (if exists)
  handoverInitiatedAt?: number;
  handoverExpiresAt?: number;

  // when accepted
  transferredAt?: number;
  transferredFromUserID?: string;
  transferredToUserID?: string;
}

export const PropertyStatus = {
  BuilderDraft: 'builderDraft', // builder created, still editable
  ReadyForHandover: 'readyForHandover', // builder marked complete
  HandoverInitiated: 'handoverInitiated', // owner invite pending (buyer invited)
  Owned: 'owned', // buyer accepted, homeowner is owner
} as const;

export type PropertyStatus = (typeof PropertyStatus)[keyof typeof PropertyStatus];

export interface IProperty extends ILocation {
  /** Backend-generated recovery code. Unsaved property drafts do not have one yet. */
  propertyCode?: string;
  orgID?: string;
  address?: IMailingAddress;
  yearBuilt?: number;
  numFloors?: number;
  bedrooms?: number;
  bathrooms?: number;
  parkingSpots?: number;
  lotArea?: AreaValue;
  status?: PropertyStatus;
  handOverMeta?: PropertyHandoverMeta;
  currentOwnershipStartedAt?: number;
}
